import React from 'react';

import { useTranslation } from 'react-i18next';

interface DisclaimerProps {
  className?: string;
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ className = '' }) => {
  const { t } = useTranslation('pleri/chat');
  return (
    <div className={`text-center ${className}`}>
      <div className="text overflow-hidden text-xs text-nowrap text-gray-500 dark:text-gray-400">
        <span className="overflow-hidden whitespace-nowrap">
          {t('pleriCanMakeMistakesPleaseDoubleCheck')}
        </span>
      </div>
    </div>
  );
};
